export default {
    en: {
        TIMEFRAME_FROM_FOREVER: 'Until',
        TIMEFRAME_TO_ETERNITY: 'Since'
    }
};
